<template>
  <section>
    <el-menu :mode="orientation">
      <template v-for="item in items">
        <template v-if="item.children && item.children.length > 0">
          <template v-if="isSubMenu(item)">
            <RecursiveSubmenu
              :item="item"
              :key="'menu_' + item.arme_id + $randomNumber()"
              :is-sub-menu="isSubMenu"
              :is-save-menu="isSaveMenu"
            ></RecursiveSubmenu>
          </template>
          <template v-else>
            <RecursiveMenuItem
              :item="item"
              :key="'menu_' + item.arme_id + $randomNumber()"
            ></RecursiveMenuItem>
          </template>
        </template>
        <template v-else>
          <el-menu-item
            :index="String('menu_' + item.arme_id + $randomNumber())"
            :key="'menu_' + item.arme_id + $randomNumber()"
          >
            {{ item.arme_nombre }}
          </el-menu-item>
        </template>
      </template>
    </el-menu>
    <el-button v-if="isSaveMenu" @click="saveMenuProfile()">Guardar</el-button>
  </section>
</template>

<script>
  import { saveMenuByProfile } from '@/api/menu_build'
  import RecursiveSubmenu from '@/components/Menu/RecursiveSubmenu'
  import RecursiveMenuItem from '@/components/Menu/RecursiveMenuItem'

  export default {
    name: 'Build',
    props: {
      items: {
        type: Array,
        required: true
      },
      isSaveMenu: {
        type: Boolean,
        default: false
      },
      orientation: {
        type: String,
        default: 'horizontal'
      }
    },

    components: {
      RecursiveSubmenu,
      RecursiveMenuItem
    },

    methods: {
      isSubMenu(item) {
        return item.children && item.children.length > 0
      },
      saveMenuProfile() {
        const selectedChild = this.items.flatMap(item =>
          item.selected ? item.children.filter(child => child.selected) : []
        )
        if (selectedChild.length === 0) {
          this.$message({
            message: 'No se ha seleccionado ningún elemento',
            type: 'warning'
          })
          return
        }
        saveMenuByProfile(selectedChild).then(() => {
          this.$message({
            message: 'Menu guardado correctamente',
            type: 'success'
          })
        })
      }
    }
  }
</script>
